import React from "react";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

function Nav() {
  let location = useLocation();
  console.log({ location });
  return (
    <header
      className="App-header"
      style={{ alignItems: "center", display: "flex" }}
    >
      <h1>TFTrainer</h1>
      <div
        className="trainer-toggle"
        style={{ flex: 1, textAlign: "baseline" }}
      >
        <Link to="/">
          <button
            className={classNames("button-link", {
              active: location.pathname !== "/items",
            })}
          >
            Champs
          </button>
        </Link>
        <Link to="/items">
          <button
            className={classNames("button-link", {
              active: location.pathname === "/items",
            })}
          >
            Items
          </button>
        </Link>
      </div>
    </header>
  );
}

export default Nav;
